import { startAppListening } from "@/store/utils";

import { companyApi } from "./company.api";

startAppListening({
  matcher: companyApi.endpoints.getCompanyByHost.matchFulfilled,
  effect: ({ payload }) => {
    sessionStorage.setItem("@company", JSON.stringify(payload));
  }
});
